import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const VastramMirror = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/#vastram-mirror', { replace: true });
    setTimeout(() => {
      const el = document.getElementById('vastram-mirror');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  }, [navigate]);

  return null;
};

export default VastramMirror;
